/*! bluemoon-error-logging - v1.1.0 - 2019-04-05 - Copyright 2017 Thomson Reuters™. All rights reserved. */
(function (angular) {
    'use strict';

    var originalOnError;
    var mod = angular.module('bluemoon.error.logging', ['bluemoon.components.analytics']);

    function getAnalyticsHeaderData () {
      var inj = window.angular.element(document.querySelector('[ng-app], [data-ng-app], html, body')).injector();
      var headers = inj && inj.get('$http').defaults.headers.common;
      if (!headers) { return {}; }
      return {
        'x-session-id': headers['x-session-id'],
        'x-user-id': headers['x-user-id'],
        'x-company-id': headers['x-company-id'],
        'x-route-id': headers['x-route-id']
      };
    }

    mod.decorator('$exceptionHandler', ['$delegate', '$analytics', function($delegate, $analytics) {
        return function(exception, cause){
            $analytics.eventTrack('frontEndException', window.angular.extend({
                message: normalizeMessage(exception),
                stack: exception.stack,
                cause: cause
            }, getAnalyticsHeaderData()));
            $delegate(exception, cause);
        };
    }]);

    mod.provider('bmErrorLogging', function () {
        var config = {
            logGlobalErrors: true
        };
        var that = this;
        this.config = function (opts) {
            if (opts) {
                Object.assign(config, opts);
            } else {
                return config;
            }
        };
        this.$get = function () {
            return that;
        };
    });

    mod.run(['$window', '$exceptionHandler', 'bmErrorLogging', function($window, $exceptionHandler, bmErrorLogging){
        var config = bmErrorLogging.config();
        if (config.logGlobalErrors) {
            originalOnError = window.onerror;

            $window.onerror = function (messageOrEvent, source, lineno, colno, error) {
                error = error || {};
                error.message = error.message || messageOrEvent;
                $exceptionHandler(error, 'Global error');
                if (originalOnError) {
                    originalOnError.apply(window, arguments);
                }
            };
        }
    }]);

    function tryJson(obj) {
        try {
            return JSON.stringify(obj);
        } catch (e) {
            console.warn(e);
        }
    }

    function normalizeMessage(exception) {
        if (exception.message){
            return exception.message;
        }
        if (exception instanceof Object) {
            return tryJson(exception);
        }
        if (typeof exception === 'string') {
            return exception;
        }
    }

})(window.angular);

(function (angular) {
    'use strict';
    /*
    *   This logic allow the posibility of have an unique module with only one name.
    *   Also allow the creation of a new module that wrap more module.
    *
    *   This also inject a few useful modules like translate, the templates (when is fonded)
    *   Be careful when modify this code, the components structure relies on this.
    *
    *   Only the first block of variable and the translation section should me modified to customize the component.
    *   The translation only should be modified to add more languages
    *
    *   * componentName: Name of the component (name on the bower.json)
    *   * moduleName: Name to the Angular Module
    *   * modulesToInject: Array with Angular Modules names to wrap in the main module
    */

    var moduleName = 'bluemoon.error.logging';
    var modulesToInject = ['ng'];

    var module;
    if (existModule(moduleName)){
      module = angular.module(moduleName);
      modulesToInject.forEach(function(dep){
        module.requires.unshift(dep);
      });
    } else {
      var dependencies = [];
      dependencies = dependencies.concat(modulesToInject);

      module = angular.module(moduleName, dependencies);
    }

    function existModule(name){
      try {
          return !!angular.module(name);
      } catch (ex) {
        if (ex.message.indexOf('[$injector:nomod]') !== -1){
          return false;
        } else {
          throw ex;
        }
      }
    }

})(window.angular);
